"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotnetAcquisitionUnexpectedError = exports.DotnetAcquisitionVersionError = exports.DotnetWSLSecurityError = exports.DotnetInvalidRuntimePatchVersion = exports.DotnetFeatureBandDoesNotExistError = exports.DotnetUnexpectedInstallerArchitectureError = exports.DotnetUnexpectedInstallerOSError = exports.DotnetNoInstallerResponseError = exports.DotnetNoInstallerFileExistsError = exports.DotnetInvalidReleasesJSONError = exports.DotnetCommandFailed = exports.InvalidUninstallRequest = exports.DotnetNotInstallRelatedCommandFailed = exports.CommandExecutionNonZeroExitFailure = exports.TimeoutSudoCommandExecutionError = exports.TimeoutSudoProcessSpawnerError = exports.DotnetPreinstallDetectionError = exports.DotnetDownloadFailure = exports.DiskIsFullError = exports.WebRequestError = exports.OSXOpenNotAvailableError = exports.DotnetInstallationValidationMissed = exports.OfflineDetectionLogicTriggered = exports.UserManualInstallFailure = exports.DotnetInstallScriptAcquisitionError = exports.SuppressedAcquisitionError = exports.DotnetInstallExpectedAbort = exports.DotnetNonAcquisitionError = exports.DotnetASPNetRuntimeFinalAcquisitionError = exports.DotnetRuntimeFinalAcquisitionError = exports.DotnetGlobalSDKAcquisitionError = exports.DotnetAcquisitionFinalError = exports.DotnetAcquisitionError = exports.DotnetAcquisitionCompleted = exports.DotnetASPNetRuntimeAcquisitionRequested = exports.DotnetGlobalSDKAcquisitionRequested = exports.DotnetRuntimeAcquisitionRequested = exports.DotnetAcquisitionRequested = exports.DotnetASPNetRuntimeAcquisitionTotalSuccessEvent = exports.DotnetGlobalSDKAcquisitionTotalSuccessEvent = exports.DotnetRuntimeAcquisitionTotalSuccessEvent = exports.DotnetAcquisitionTotalSuccessEvent = exports.DotnetASPNetRuntimeAcquisitionStarted = exports.DotnetGlobalSDKAcquisitionStarted = exports.DotnetSDKAcquisitionStarted = exports.DotnetRuntimeAcquisitionStarted = exports.DotnetAcquisitionStarted = exports.GenericModalEvent = exports.EventBasedError = exports.EventCancellationError = void 0;
exports.NoExtensionIdProvided = exports.DotnetUninstallSkipped = exports.DotnetUninstallFailed = exports.DotnetUninstallCompleted = exports.DotnetUninstallStarted = exports.FileDoesNotExist = exports.FeatureBandDoesNotExist = exports.TriedToExitMasterSudoProcess = exports.FileToWipe = exports.ProxyUsed = exports.EmptyDirectoryToWipe = exports.WebRequestTimeUnknown = exports.WebRequestCachedTime = exports.WebRequestTime = exports.CommandExecutionTimer = exports.WebRequestTimer = exports.DuplicateInstallDetected = exports.DotnetVersionCategorizedEvent = exports.FileIsNotBusy = exports.FileIsBusy = exports.UtilizingExistingInstallPromise = exports.DotnetUnableToCheckPATHArchitecture = exports.DotnetFileIntegrityFailureEvent = exports.DotnetVisibleWarningEvent = exports.DotnetCustomMessageEvent = exports.DotnetFallbackInstallScriptUsed = exports.DotnetAcquisitionDeletion = exports.DotnetAcquisitionMessage = exports.DotnetExistingPathResolutionCompleted = exports.DotnetInstallScriptAcquisitionCompleted = exports.DotnetVersionResolutionCompleted = exports.DotnetUninstallAllCompleted = exports.DotnetUninstallAllStarted = exports.DotnetCommandSucceeded = exports.DotnetAcquisitionSuccessEvent = exports.DotnetAcquisitionDistroUnknownError = exports.DotnetInstallationValidationError = exports.DotnetCustomLinuxInstallExistsError = exports.DotnetConflictingLinuxInstallTypesError = exports.DotnetVersionResolutionError = exports.DotnetAcquisitionTimeoutError = exports.PowershellBadExecutionPolicy = exports.PowershellBadLanguageMode = exports.DotnetOfflineFailure = exports.DotnetNonZeroInstallerExitCodeError = exports.DotnetDebuggingMessage = exports.DotnetInstallCancelledByUserError = exports.DotnetConflictingGlobalWindowsInstallError = exports.DotnetAcquisitionScriptError = exports.DotnetAcquisitionInstallError = void 0;
exports.GlobalAcquisitionContextMenuOpened = exports.DotnetFileIntegrityCheckEvent = exports.DotnetCommandNotFoundEvent = exports.DotnetVSCodeExtensionChange = exports.DotnetVSCodeExtensionHasInstallRequest = exports.DotnetVSCodeExtensionFound = exports.FoundDistroVersionDetails = exports.DistroPackagesSearch = exports.FeedInjectionFinished = exports.FeedInjectionStarted = exports.FeedInjection = exports.DistroSupport = exports.DotnetTelemetrySettingEvent = exports.DotnetFindPathDidNotMeetCondition = exports.DotnetFindPathNoPathMetCondition = exports.DotnetFindPathMetCondition = exports.DotnetFindPathRootPATHFound = exports.DotnetFindPathRootUnderEmulationButNoneSet = exports.DotnetFindPathRootEmulationPATHFound = exports.DotnetFindPathLookupRootPATH = exports.DotnetFindPathNoRuntimesOnHost = exports.DotnetFindPathNoHostOnFileSystem = exports.DotnetFindPathOnFileSystem = exports.SudoDirDeletionFailed = exports.SudoDirCreationFailed = exports.DotnetFindPathNoHostOnRegistry = exports.DotnetFindPathOnRegistry = exports.DotnetFindPathHostFxrResolutionLookup = exports.DotnetConditionsValidated = exports.DotnetFindPathRealPATHFound = exports.DotnetFindPathLookupRealPATH = exports.DotnetFindPathPATHFound = exports.DotnetFindPathLookupPATH = exports.DotnetFindPathSettingFound = exports.CacheAliasCreated = exports.DotnetFindPathLookupSetting = exports.CacheGetEvent = exports.CachePutEvent = exports.CacheClearEvent = exports.WebCacheClearEvent = exports.DotnetFindPathCommandInvoked = exports.DotnetWSLOperationOutputEvent = exports.DotnetWSLCheckEvent = exports.AddTrackingVersions = exports.SkipAddingInstallEvent = exports.RemovingOwnerFromList = exports.RemovingExtensionFromList = exports.RemovingVersionFromExtensionState = exports.FoundTrackingVersions = exports.ConvertingLegacyInstallRecord = void 0;
exports.DotnetAcquisitionInProgress = exports.DotnetAcquisitionPartialInstallation = exports.DotnetFileWriteRequestEvent = exports.GenericDotnetLockEvent = exports.DotnetLockEvent = exports.DotnetFileEvent = exports.DotnetInstallLinuxChecks = exports.FailedToRunSudoCommand = exports.NetInstallerEndExecutionEvent = exports.NetInstallerBeginExecutionEvent = exports.DotnetOfflineWarning = exports.DotnetOfflineInstallUsed = exports.DotnetUpgradedEvent = exports.DotnetVersionParseEvent = exports.CommandExecutionUnknownCommandExecutionAttempt = exports.CommandExecutionUserRejectedPasswordRequest = exports.CommandExecutionUnderSudoEvent = exports.CommandExecutionUserCompletedDialogueEvent = exports.CommandExecutionUserAskDialogueEvent = exports.SudoProcCommandExchangeEnd = exports.WaitingForDotnetInstallerResponse = exports.SudoProcCommandExchangePing = exports.SudoProcCommandExchangeBegin = exports.SudoProcAliveCheckEnd = exports.SudoProcAliveCheckBegin = exports.CommandExecutionEvent = exports.CommandExecutionStatusEvent = exports.CommandExecutionSignalSentEvent = exports.CommandExecutionNoStatusCodeWarning = exports.DotnetFakeSDKEnvironmentVariableTriggered = exports.DotnetLegacyInstallRemovalRequestEvent = exports.DotnetLegacyInstallDetectedEvent = exports.DotnetInstallIdCreatedEvent = exports.DotnetCommandFallbackOSEvent = exports.DotnetCommandFallbackArchitectureEvent = exports.DotnetAlternativeCommandFoundEvent = exports.DotnetGlobalAcquisitionCompletionEvent = exports.DotnetCompletedGlobalInstallerExecution = exports.DotnetBeginGlobalInstallerExecution = exports.CommandProcessorExecutionEnd = exports.CommandProcessorExecutionBegin = exports.CommandProcessesExecutionFailureNonTerminal = exports.DotnetGlobalVersionResolutionCompletionEvent = exports.DotnetGlobalAcquisitionBeginEvent = exports.CommandExecutionStdError = exports.NoMatchingInstallToStopTracking = exports.CommandExecutionStdOut = exports.UserManualInstallSuccess = exports.UserManualInstallRequested = exports.UserManualInstallVersionChosen = void 0;
exports.TestAcquireCalled = exports.DotnetPreinstallDetected = exports.WebRequestInitiated = exports.WebRequestUsingAltClient = exports.WebRequestSent = exports.DotnetAcquisitionStatusResolved = exports.DotnetAcquisitionStatusUndefined = exports.DotnetAcquisitionStatusRequested = exports.DotnetInstallationValidated = exports.DotnetAcquisitionScriptOutput = exports.DotnetAcquisitionThoughtInstalledButNot = exports.DotnetAcquisitionMissingLinuxDependencies = exports.DotnetAcquisitionAlreadyInstalled = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const fs = require("fs");
const path = require("path");
const DotnetInstall_1 = require("../Acquisition/DotnetInstall");
const EventType_1 = require("./EventType");
const IEvent_1 = require("./IEvent");
const TelemetryUtilities_1 = require("./TelemetryUtilities");
class EventCancellationError extends Error {
    constructor(eventType, msg, stack) {
        super(msg);
        this.eventType = eventType;
    }
}
exports.EventCancellationError = EventCancellationError;
class EventBasedError extends Error {
    constructor(eventType, msg, stack) {
        super(msg);
        this.eventType = eventType;
    }
}
exports.EventBasedError = EventBasedError;
class GenericModalEvent extends IEvent_1.IEvent {
}
exports.GenericModalEvent = GenericModalEvent;
class DotnetAcquisitionStarted extends GenericModalEvent {
    constructor(install, startingVersion, requestingExtensionId = '') {
        super();
        this.install = install;
        this.startingVersion = startingVersion;
        this.requestingExtensionId = requestingExtensionId;
        this.eventName = 'DotnetAcquisitionStarted';
        this.type = EventType_1.EventType.DotnetAcquisitionStart;
        this.mode = install.installMode;
        this.installType = install.isGlobal ? 'global' : 'local';
    }
    getProperties() {
        return Object.assign(Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.install)), { AcquisitionStartVersion: this.startingVersion, AcquisitionInstallId: this.install.installId, extensionId: this.requestingExtensionId });
    }
}
exports.DotnetAcquisitionStarted = DotnetAcquisitionStarted;
class DotnetAcquisitionStartedBase extends IEvent_1.IEvent {
    constructor(requestingExtensionId = '') {
        super();
        this.requestingExtensionId = requestingExtensionId;
    }
    getProperties() {
        return { extensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingExtensionId) };
    }
}
class DotnetRuntimeAcquisitionStarted extends DotnetAcquisitionStartedBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetRuntimeAcquisitionStarted';
        this.type = EventType_1.EventType.DotnetModalChildEvent;
    }
}
exports.DotnetRuntimeAcquisitionStarted = DotnetRuntimeAcquisitionStarted;
class DotnetSDKAcquisitionStarted extends DotnetAcquisitionStartedBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetSDKAcquisitionStarted';
        this.type = EventType_1.EventType.DotnetModalChildEvent;
    }
}
exports.DotnetSDKAcquisitionStarted = DotnetSDKAcquisitionStarted;
class DotnetGlobalSDKAcquisitionStarted extends DotnetAcquisitionStartedBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalSDKAcquisitionStarted';
        this.type = EventType_1.EventType.DotnetModalChildEvent;
    }
}
exports.DotnetGlobalSDKAcquisitionStarted = DotnetGlobalSDKAcquisitionStarted;
class DotnetASPNetRuntimeAcquisitionStarted extends DotnetAcquisitionStartedBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetASPNetRuntimeAcquisitionStarted';
        this.type = EventType_1.EventType.DotnetModalChildEvent;
    }
}
exports.DotnetASPNetRuntimeAcquisitionStarted = DotnetASPNetRuntimeAcquisitionStarted;
class DotnetAcquisitionTotalSuccessEvent extends GenericModalEvent {
    constructor(startingVersion, install, requestingExtensionId = '', finalPath) {
        super();
        this.startingVersion = startingVersion;
        this.install = install;
        this.requestingExtensionId = requestingExtensionId;
        this.finalPath = finalPath;
        this.type = EventType_1.EventType.DotnetTotalSuccessEvent;
        this.eventName = 'DotnetAcquisitionTotalSuccessEvent';
        this.mode = install.installMode;
        this.installType = install.isGlobal ? 'global' : 'local';
    }
    getProperties() {
        return Object.assign(Object.assign({ AcquisitionStartVersion: this.startingVersion, AcquisitionInstallId: this.install.installId }, (0, DotnetInstall_1.InstallToStrings)(this.install)), { ExtensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingExtensionId), FinalPath: this.finalPath });
    }
}
exports.DotnetAcquisitionTotalSuccessEvent = DotnetAcquisitionTotalSuccessEvent;
class DotnetAcquisitionTotalSuccessEventBase extends IEvent_1.IEvent {
    constructor(installId) {
        super();
        this.installId = installId;
        this.type = EventType_1.EventType.DotnetModalChildEvent;
    }
    getProperties() {
        return Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.installId));
    }
}
class DotnetRuntimeAcquisitionTotalSuccessEvent extends DotnetAcquisitionTotalSuccessEventBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetRuntimeAcquisitionTotalSuccessEvent';
    }
}
exports.DotnetRuntimeAcquisitionTotalSuccessEvent = DotnetRuntimeAcquisitionTotalSuccessEvent;
class DotnetGlobalSDKAcquisitionTotalSuccessEvent extends DotnetAcquisitionTotalSuccessEventBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalSDKAcquisitionTotalSuccessEvent';
    }
}
exports.DotnetGlobalSDKAcquisitionTotalSuccessEvent = DotnetGlobalSDKAcquisitionTotalSuccessEvent;
class DotnetASPNetRuntimeAcquisitionTotalSuccessEvent extends DotnetAcquisitionTotalSuccessEventBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetASPNetRuntimeAcquisitionTotalSuccessEvent';
    }
}
exports.DotnetASPNetRuntimeAcquisitionTotalSuccessEvent = DotnetASPNetRuntimeAcquisitionTotalSuccessEvent;
class DotnetAcquisitionRequested extends GenericModalEvent {
    constructor(startingVersion, requestingId = '', mode, installType) {
        super();
        this.startingVersion = startingVersion;
        this.requestingId = requestingId;
        this.eventName = 'DotnetAcquisitionRequested';
        this.type = EventType_1.EventType.DotnetTotalSuccessEvent;
        this.mode = mode;
        this.installType = installType;
    }
    getProperties() {
        return {
            AcquisitionStartVersion: this.startingVersion,
            RequestingExtensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingId)
        };
    }
}
exports.DotnetAcquisitionRequested = DotnetAcquisitionRequested;
class DotnetAcquisitionRequestedEventBase extends IEvent_1.IEvent {
    constructor(startingVersion, requestingId = '', mode) {
        super();
        this.startingVersion = startingVersion;
        this.requestingId = requestingId;
        this.mode = mode;
        this.type = EventType_1.EventType.DotnetModalChildEvent;
    }
    getProperties() {
        return {
            AcquisitionStartVersion: this.startingVersion,
            RequestingExtensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingId),
            Mode: this.mode
        };
    }
}
class DotnetRuntimeAcquisitionRequested extends DotnetAcquisitionRequestedEventBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetRuntimeAcquisitionRequested';
    }
}
exports.DotnetRuntimeAcquisitionRequested = DotnetRuntimeAcquisitionRequested;
class DotnetGlobalSDKAcquisitionRequested extends DotnetAcquisitionRequestedEventBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalSDKAcquisitionRequested';
    }
}
exports.DotnetGlobalSDKAcquisitionRequested = DotnetGlobalSDKAcquisitionRequested;
class DotnetASPNetRuntimeAcquisitionRequested extends DotnetAcquisitionRequestedEventBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetASPNetRuntimeAcquisitionRequested';
    }
}
exports.DotnetASPNetRuntimeAcquisitionRequested = DotnetASPNetRuntimeAcquisitionRequested;
class DotnetAcquisitionCompleted extends IEvent_1.IEvent {
    constructor(install, dotnetPath, version) {
        super();
        this.install = install;
        this.dotnetPath = dotnetPath;
        this.version = version;
        this.eventName = 'DotnetAcquisitionCompleted';
        this.type = EventType_1.EventType.DotnetAcquisitionCompleted;
    }
    getProperties(telemetry = false) {
        if (telemetry) {
            return Object.assign(Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.install)), { AcquisitionCompletedInstallId: this.install.installId, AcquisitionCompletedVersion: this.version });
        }
        else {
            return Object.assign(Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.install)), { AcquisitionCompletedVersion: this.version, AcquisitionCompletedInstallId: this.install.installId, AcquisitionCompletedDotnetPath: this.dotnetPath });
        }
    }
}
exports.DotnetAcquisitionCompleted = DotnetAcquisitionCompleted;
class DotnetAcquisitionError extends IEvent_1.IEvent {
    /**
     *
     * @param error The error that triggered, so the call stack, etc. can be analyzed.
     * @param install For acquisition errors, you MUST include this install id. For commands unrelated to acquiring or managing a specific dotnet version, you
     * have the option to leave this parameter null. If it is NULL during acquisition the extension CANNOT properly manage what it has finished installing or not.
     */
    constructor(error, install) {
        super();
        this.error = error;
        this.install = install;
        this.type = EventType_1.EventType.DotnetAcquisitionError;
        this.isError = true;
    }
    getProperties(telemetry = false) {
        var _a, _b;
        return Object.assign({ ErrorName: this.error.name, ErrorMessage: this.error.message, StackTrace: this.error.stack ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : '', InstallId: (_b = (_a = this.install) === null || _a === void 0 ? void 0 : _a.installId) !== null && _b !== void 0 ? _b : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install));
    }
}
exports.DotnetAcquisitionError = DotnetAcquisitionError;
class DotnetAcquisitionFinalError extends GenericModalEvent {
    constructor(error, originalEventName, install) {
        super();
        this.error = error;
        this.originalEventName = originalEventName;
        this.install = install;
        this.type = EventType_1.EventType.DotnetAcquisitionFinalError;
        this.eventName = 'DotnetAcquisitionFinalError';
        this.mode = install.installMode;
        this.installType = install.isGlobal ? 'global' : 'local';
    }
    getProperties(telemetry = false) {
        var _a, _b;
        return Object.assign({ ErrorName: this.error.name, ErrorMessage: this.error.message, StackTrace: this.error.stack ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : '', InstallId: (_b = (_a = this.install) === null || _a === void 0 ? void 0 : _a.installId) !== null && _b !== void 0 ? _b : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install));
    }
}
exports.DotnetAcquisitionFinalError = DotnetAcquisitionFinalError;
/**
 * @remarks A wrapper around events to detect them as a failure to install.
 * This allows us to count all errors and analyze them into categories.
 * The event name for the failure cause is stored in the originalEventName property.
 */
class DotnetAcquisitionFinalErrorBase extends DotnetAcquisitionError {
    constructor(error, originalEventName, install) {
        super(error, install);
        this.error = error;
        this.originalEventName = originalEventName;
        this.install = install;
        this.type = EventType_1.EventType.DotnetAcquisitionFinalError;
    }
    getProperties(telemetry = false) {
        var _a, _b;
        return Object.assign({ FailureMode: this.originalEventName, ErrorName: this.error.name, ErrorMessage: this.error.message, StackTrace: this.error.stack ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : '', InstallId: (_b = (_a = this.install) === null || _a === void 0 ? void 0 : _a.installId) !== null && _b !== void 0 ? _b : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install));
    }
}
class DotnetGlobalSDKAcquisitionError extends DotnetAcquisitionFinalErrorBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalSDKAcquisitionError';
    }
}
exports.DotnetGlobalSDKAcquisitionError = DotnetGlobalSDKAcquisitionError;
class DotnetRuntimeFinalAcquisitionError extends DotnetAcquisitionFinalErrorBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetRuntimeFinalAcquisitionError';
    }
}
exports.DotnetRuntimeFinalAcquisitionError = DotnetRuntimeFinalAcquisitionError;
class DotnetASPNetRuntimeFinalAcquisitionError extends DotnetAcquisitionFinalErrorBase {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetASPNetRuntimeFinalAcquisitionError';
    }
}
exports.DotnetASPNetRuntimeFinalAcquisitionError = DotnetASPNetRuntimeFinalAcquisitionError;
class DotnetNonAcquisitionError extends IEvent_1.IEvent {
    constructor(error) {
        super();
        this.error = error;
        this.type = EventType_1.EventType.DotnetAcquisitionError;
        this.isError = true;
    }
    getProperties(telemetry = false) {
        return {
            ErrorName: this.error.name,
            ErrorMessage: this.error.message,
            StackTrace: this.error.stack ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : ''
        };
    }
}
exports.DotnetNonAcquisitionError = DotnetNonAcquisitionError;
class DotnetInstallExpectedAbort extends IEvent_1.IEvent {
    /**
     *
     * @param error The error that triggered, so the call stack, etc. can be analyzed.
     * @param install For acquisition errors, you MUST include this install id. For commands unrelated to acquiring or managing a specific dotnet version, you
     * have the option to leave this parameter null. If it is NULL during acquisition the extension CANNOT properly manage what it has finished installing or not.
     */
    constructor(error, install) {
        super();
        this.error = error;
        this.install = install;
        this.type = EventType_1.EventType.DotnetInstallExpectedAbort;
        this.isError = true;
    }
    getProperties(telemetry = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this.install) {
            return Object.assign({ ErrorName: (_b = (_a = this.error) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : 'GenericError', ErrorMessage: (_d = (_c = this.error) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : 'ErrorMessage not provided', StackTrace: ((_e = this.error) === null || _e === void 0 ? void 0 : _e.stack) ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : '', InstallId: (_g = (_f = this.install) === null || _f === void 0 ? void 0 : _f.installId) !== null && _g !== void 0 ? _g : 'null' }, (_h = (0, DotnetInstall_1.InstallToStrings)(this.install)) !== null && _h !== void 0 ? _h : 'No Install Info');
        }
        else {
            return {
                ErrorName: this.error.name,
                ErrorMessage: this.error.message,
                StackTrace: this.error.stack ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : '',
                InstallId: 'null'
            };
        }
    }
}
exports.DotnetInstallExpectedAbort = DotnetInstallExpectedAbort;
class SuppressedAcquisitionError extends IEvent_1.IEvent {
    constructor(error, supplementalMessage) {
        super();
        this.error = error;
        this.supplementalMessage = supplementalMessage;
        this.eventName = 'SuppressedAcquisitionError';
        this.type = EventType_1.EventType.SuppressedAcquisitionError;
    }
    getProperties(telemetry = false) {
        return {
            SupplementMessage: this.supplementalMessage,
            ErrorName: this.error.name,
            ErrorMessage: telemetry ? 'redacted' : TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.message),
            StackTrace: telemetry ? 'redacted' : (this.error.stack ? TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.error.stack) : '')
        };
    }
}
exports.SuppressedAcquisitionError = SuppressedAcquisitionError;
class DotnetInstallScriptAcquisitionError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInstallScriptAcquisitionError';
    }
}
exports.DotnetInstallScriptAcquisitionError = DotnetInstallScriptAcquisitionError;
class UserManualInstallFailure extends SuppressedAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'UserManualInstallFailure';
    }
}
exports.UserManualInstallFailure = UserManualInstallFailure;
class OfflineDetectionLogicTriggered extends SuppressedAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'OfflineDetectionLogicTriggered';
    }
}
exports.OfflineDetectionLogicTriggered = OfflineDetectionLogicTriggered;
class DotnetInstallationValidationMissed extends SuppressedAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInstallationValidationMissed';
    }
}
exports.DotnetInstallationValidationMissed = DotnetInstallationValidationMissed;
class OSXOpenNotAvailableError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'OSXOpenNotAvailableError';
    }
}
exports.OSXOpenNotAvailableError = OSXOpenNotAvailableError;
class WebRequestError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'WebRequestError';
    }
}
exports.WebRequestError = WebRequestError;
class DiskIsFullError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DiskIsFullError';
    }
}
exports.DiskIsFullError = DiskIsFullError;
class DotnetDownloadFailure extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetDownloadFailure';
    }
}
exports.DotnetDownloadFailure = DotnetDownloadFailure;
class DotnetPreinstallDetectionError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetPreinstallDetectionError';
    }
}
exports.DotnetPreinstallDetectionError = DotnetPreinstallDetectionError;
class TimeoutSudoProcessSpawnerError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'TimeoutSudoProcessSpawnerError';
    }
}
exports.TimeoutSudoProcessSpawnerError = TimeoutSudoProcessSpawnerError;
class TimeoutSudoCommandExecutionError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'TimeoutSudoCommandExecutionError';
    }
}
exports.TimeoutSudoCommandExecutionError = TimeoutSudoCommandExecutionError;
class CommandExecutionNonZeroExitFailure extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionNonZeroExitFailure';
    }
}
exports.CommandExecutionNonZeroExitFailure = CommandExecutionNonZeroExitFailure;
class DotnetNotInstallRelatedCommandFailed extends DotnetNonAcquisitionError {
    constructor(error, command) {
        super(error);
        this.command = command;
        this.eventName = 'DotnetNotInstallRelatedCommandFailed';
    }
    getProperties(telemetry = false) {
        return {
            ErrorMessage: this.error.message,
            CommandName: this.command,
            ErrorName: this.error.name,
            StackTrace: this.error.stack ? this.error.stack : ''
        };
    }
}
exports.DotnetNotInstallRelatedCommandFailed = DotnetNotInstallRelatedCommandFailed;
class InvalidUninstallRequest extends DotnetNonAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'InvalidUninstallRequest';
    }
}
exports.InvalidUninstallRequest = InvalidUninstallRequest;
class DotnetCommandFailed extends DotnetAcquisitionError {
    constructor(error, command, install) {
        super(error, install);
        this.command = command;
        this.eventName = 'DotnetCommandFailed';
    }
    getProperties(telemetry = false) {
        var _a, _b;
        return Object.assign({ ErrorMessage: this.error.message, CommandName: this.command, ErrorName: this.error.name, StackTrace: this.error.stack ? this.error.stack : '', InstallId: (_b = (_a = this.install) === null || _a === void 0 ? void 0 : _a.installId) !== null && _b !== void 0 ? _b : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install));
    }
}
exports.DotnetCommandFailed = DotnetCommandFailed;
class DotnetInvalidReleasesJSONError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInvalidReleasesJSONError';
    }
}
exports.DotnetInvalidReleasesJSONError = DotnetInvalidReleasesJSONError;
class DotnetNoInstallerFileExistsError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetNoInstallerFileExistsError';
    }
}
exports.DotnetNoInstallerFileExistsError = DotnetNoInstallerFileExistsError;
class DotnetNoInstallerResponseError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetNoInstallerResponseError';
    }
}
exports.DotnetNoInstallerResponseError = DotnetNoInstallerResponseError;
class DotnetUnexpectedInstallerOSError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUnexpectedInstallerOSError';
    }
}
exports.DotnetUnexpectedInstallerOSError = DotnetUnexpectedInstallerOSError;
class DotnetUnexpectedInstallerArchitectureError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUnexpectedInstallerArchitectureError';
    }
}
exports.DotnetUnexpectedInstallerArchitectureError = DotnetUnexpectedInstallerArchitectureError;
class DotnetFeatureBandDoesNotExistError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFeatureBandDoesNotExistError';
    }
}
exports.DotnetFeatureBandDoesNotExistError = DotnetFeatureBandDoesNotExistError;
class DotnetInvalidRuntimePatchVersion extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInvalidRuntimePatchVersion';
    }
}
exports.DotnetInvalidRuntimePatchVersion = DotnetInvalidRuntimePatchVersion;
class DotnetWSLSecurityError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetWSLSecurityError';
    }
}
exports.DotnetWSLSecurityError = DotnetWSLSecurityError;
class DotnetAcquisitionVersionError extends DotnetAcquisitionError {
    constructor(error, install) {
        super(error, install);
        this.install = install;
    }
    getProperties(telemetry = false) {
        var _a, _b, _c;
        return this.install ? Object.assign(Object.assign({ ErrorMessage: this.error.message, AcquisitionErrorInstallId: (_a = this.install.installId) !== null && _a !== void 0 ? _a : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install)), { ErrorName: this.error.name, StackTrace: (_b = this.error.stack) !== null && _b !== void 0 ? _b : '' }) :
            {
                ErrorMessage: this.error.message,
                AcquisitionErrorInstallId: 'null',
                ErrorName: this.error.name,
                StackTrace: (_c = this.error.stack) !== null && _c !== void 0 ? _c : ''
            };
    }
}
exports.DotnetAcquisitionVersionError = DotnetAcquisitionVersionError;
class DotnetAcquisitionUnexpectedError extends DotnetAcquisitionVersionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAcquisitionUnexpectedError';
    }
}
exports.DotnetAcquisitionUnexpectedError = DotnetAcquisitionUnexpectedError;
class DotnetAcquisitionInstallError extends DotnetAcquisitionVersionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAcquisitionInstallError';
    }
}
exports.DotnetAcquisitionInstallError = DotnetAcquisitionInstallError;
class DotnetAcquisitionScriptError extends DotnetAcquisitionVersionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAcquisitionScriptError';
    }
}
exports.DotnetAcquisitionScriptError = DotnetAcquisitionScriptError;
class DotnetConflictingGlobalWindowsInstallError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetConflictingGlobalWindowsInstallError';
    }
}
exports.DotnetConflictingGlobalWindowsInstallError = DotnetConflictingGlobalWindowsInstallError;
class DotnetInstallCancelledByUserError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInstallCancelledByUserError';
    }
}
exports.DotnetInstallCancelledByUserError = DotnetInstallCancelledByUserError;
class DotnetDebuggingMessage extends IEvent_1.IEvent {
    constructor(message) {
        super();
        this.message = message;
        this.eventName = 'DotnetDebuggingMessage';
        this.type = EventType_1.EventType.DotnetDebuggingMessage;
        this.message = message;
    }
    getProperties() {
        return { message: this.message };
    }
}
exports.DotnetDebuggingMessage = DotnetDebuggingMessage;
class DotnetNonZeroInstallerExitCodeError extends DotnetAcquisitionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetNonZeroInstallerExitCodeError';
    }
}
exports.DotnetNonZeroInstallerExitCodeError = DotnetNonZeroInstallerExitCodeError;
class DotnetOfflineFailure extends DotnetAcquisitionVersionError {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetOfflineFailure';
    }
}
exports.DotnetOfflineFailure = DotnetOfflineFailure;
class PowershellBadLanguageMode extends DotnetAcquisitionVersionError {
    constructor() {
        super(...arguments);
        this.eventName = 'PowershellBadLanguageMode';
    }
}
exports.PowershellBadLanguageMode = PowershellBadLanguageMode;
class PowershellBadExecutionPolicy extends DotnetAcquisitionVersionError {
    constructor() {
        super(...arguments);
        this.eventName = 'PowershellBadExecutionPolicy';
    }
}
exports.PowershellBadExecutionPolicy = PowershellBadExecutionPolicy;
class DotnetAcquisitionTimeoutError extends DotnetAcquisitionVersionError {
    constructor(error, installId, timeoutValue) {
        super(error, installId);
        this.timeoutValue = timeoutValue;
        this.eventName = 'DotnetAcquisitionTimeoutError';
    }
    getProperties(telemetry = false) {
        if (this.install) {
            return Object.assign(Object.assign({ ErrorMessage: this.error.message, TimeoutValue: this.timeoutValue.toString() }, (0, DotnetInstall_1.InstallToStrings)(this.install)), { ErrorName: this.error.name, StackTrace: this.error.stack ? this.error.stack : '' });
        }
        else {
            return {
                ErrorMessage: this.error.message,
                TimeoutValue: this.timeoutValue.toString(),
                ErrorName: this.error.name,
                StackTrace: this.error.stack ? this.error.stack : ''
            };
        }
    }
}
exports.DotnetAcquisitionTimeoutError = DotnetAcquisitionTimeoutError;
class DotnetVersionResolutionError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetVersionResolutionError';
    }
}
exports.DotnetVersionResolutionError = DotnetVersionResolutionError;
class DotnetConflictingLinuxInstallTypesError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetConflictingLinuxInstallTypesError';
    }
}
exports.DotnetConflictingLinuxInstallTypesError = DotnetConflictingLinuxInstallTypesError;
class DotnetCustomLinuxInstallExistsError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetCustomLinuxInstallExistsError';
    }
}
exports.DotnetCustomLinuxInstallExistsError = DotnetCustomLinuxInstallExistsError;
class DotnetInstallationValidationError extends DotnetAcquisitionVersionError {
    constructor(error, install, dotnetPath) {
        super(error, install);
        this.dotnetPath = dotnetPath;
        this.eventName = 'DotnetInstallationValidationError';
        this.fileStructure = this.getFileStructure();
    }
    getProperties(telemetry = false) {
        var _a, _b, _c, _d;
        if (this.install) {
            return Object.assign(Object.assign({ ErrorMessage: this.error.message, AcquisitionErrorInstallId: (_b = (_a = this.install) === null || _a === void 0 ? void 0 : _a.installId) !== null && _b !== void 0 ? _b : 'null', InstallId: (_d = (_c = this.install) === null || _c === void 0 ? void 0 : _c.installId) !== null && _d !== void 0 ? _d : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install)), { ErrorName: this.error.name, StackTrace: this.error.stack ? this.error.stack : '', FileStructure: this.fileStructure });
        }
        else {
            return {
                ErrorMessage: this.error.message,
                AcquisitionErrorInstallId: 'null',
                InstallId: 'null',
                ErrorName: this.error.name,
                StackTrace: this.error.stack ? this.error.stack : '',
                FileStructure: this.fileStructure
            };
        }
    }
    getFileStructure() {
        const folderPath = path.dirname(this.dotnetPath);
        if (!fs.existsSync(folderPath)) {
            return `Dotnet Path (${path.basename(folderPath)}) does not exist`;
        }
        // Get 2 levels worth of content of the folder
        let files = fs.readdirSync(folderPath).map(file => path.join(folderPath, file));
        for (const file of files) {
            if (fs.statSync(file).isDirectory()) {
                files = files.concat(fs.readdirSync(file).map(fileName => path.join(file, fileName)));
            }
        }
        const relativeFiles = [];
        for (const file of files) {
            relativeFiles.push(path.relative(path.dirname(folderPath), file));
        }
        return relativeFiles.join('\n');
    }
}
exports.DotnetInstallationValidationError = DotnetInstallationValidationError;
class DotnetAcquisitionDistroUnknownError extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAcquisitionDistroUnknownError';
    }
    getProperties(telemetry = false) {
        var _a, _b;
        return Object.assign({ ErrorMessage: this.error.message, ErrorName: this.error.name, StackTrace: this.error.stack ? this.error.stack : '', InstallId: (_b = (_a = this.install) === null || _a === void 0 ? void 0 : _a.installId) !== null && _b !== void 0 ? _b : 'null' }, (0, DotnetInstall_1.InstallToStrings)(this.install));
    }
}
exports.DotnetAcquisitionDistroUnknownError = DotnetAcquisitionDistroUnknownError;
class DotnetAcquisitionSuccessEvent extends IEvent_1.IEvent {
    constructor() {
        super(...arguments);
        this.type = EventType_1.EventType.DotnetAcquisitionSuccessEvent;
    }
    getProperties() {
        return undefined;
    }
}
exports.DotnetAcquisitionSuccessEvent = DotnetAcquisitionSuccessEvent;
class DotnetCommandSucceeded extends DotnetAcquisitionSuccessEvent {
    constructor(commandName) {
        super();
        this.commandName = commandName;
        this.eventName = 'DotnetCommandSucceeded';
    }
    getProperties() {
        return { CommandName: this.commandName };
    }
}
exports.DotnetCommandSucceeded = DotnetCommandSucceeded;
class DotnetUninstallAllStarted extends DotnetAcquisitionSuccessEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUninstallAllStarted';
    }
}
exports.DotnetUninstallAllStarted = DotnetUninstallAllStarted;
class DotnetUninstallAllCompleted extends DotnetAcquisitionSuccessEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUninstallAllCompleted';
    }
}
exports.DotnetUninstallAllCompleted = DotnetUninstallAllCompleted;
class DotnetVersionResolutionCompleted extends DotnetAcquisitionSuccessEvent {
    constructor(requestedVersion, resolvedVersion) {
        super();
        this.requestedVersion = requestedVersion;
        this.resolvedVersion = resolvedVersion;
        this.eventName = 'DotnetVersionResolutionCompleted';
    }
    getProperties() {
        return {
            RequestedVersion: this.requestedVersion,
            ResolvedVersion: this.resolvedVersion
        };
    }
}
exports.DotnetVersionResolutionCompleted = DotnetVersionResolutionCompleted;
class DotnetInstallScriptAcquisitionCompleted extends DotnetAcquisitionSuccessEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInstallScriptAcquisitionCompleted';
    }
}
exports.DotnetInstallScriptAcquisitionCompleted = DotnetInstallScriptAcquisitionCompleted;
class DotnetExistingPathResolutionCompleted extends DotnetAcquisitionSuccessEvent {
    constructor(resolvedPath) {
        super();
        this.resolvedPath = resolvedPath;
        this.eventName = 'DotnetExistingPathResolutionCompleted';
    }
    getProperties(telemetry = false) {
        return telemetry ? undefined : { ConfiguredPath: this.resolvedPath };
    }
}
exports.DotnetExistingPathResolutionCompleted = DotnetExistingPathResolutionCompleted;
class DotnetAcquisitionMessage extends IEvent_1.IEvent {
    constructor() {
        super(...arguments);
        this.type = EventType_1.EventType.DotnetAcquisitionMessage;
    }
    getProperties() {
        return {};
    }
}
exports.DotnetAcquisitionMessage = DotnetAcquisitionMessage;
class DotnetAcquisitionDeletion extends DotnetAcquisitionMessage {
    constructor(folderPath) {
        super();
        this.folderPath = folderPath;
        this.eventName = 'DotnetAcquisitionDeletion';
    }
    getProperties(telemetry = false) {
        return telemetry ? undefined : { DeletedFolderPath: this.folderPath };
    }
}
exports.DotnetAcquisitionDeletion = DotnetAcquisitionDeletion;
class DotnetFallbackInstallScriptUsed extends DotnetAcquisitionMessage {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFallbackInstallScriptUsed';
    }
}
exports.DotnetFallbackInstallScriptUsed = DotnetFallbackInstallScriptUsed;
class DotnetCustomMessageEvent extends DotnetAcquisitionMessage {
    constructor(eventMessage) {
        super();
        this.eventMessage = eventMessage;
    }
    getProperties() {
        return { Message: this.eventMessage };
    }
}
exports.DotnetCustomMessageEvent = DotnetCustomMessageEvent;
class DotnetVisibleWarningEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.type = EventType_1.EventType.DotnetVisibleWarning;
    }
}
exports.DotnetVisibleWarningEvent = DotnetVisibleWarningEvent;
class DotnetFileIntegrityFailureEvent extends DotnetVisibleWarningEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFileIntegrityFailureEvent';
    }
}
exports.DotnetFileIntegrityFailureEvent = DotnetFileIntegrityFailureEvent;
class DotnetUnableToCheckPATHArchitecture extends DotnetVisibleWarningEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUnableToCheckPATHArchitecture';
    }
}
exports.DotnetUnableToCheckPATHArchitecture = DotnetUnableToCheckPATHArchitecture;
class UtilizingExistingInstallPromise extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'UtilizingExistingInstallPromise';
    }
}
exports.UtilizingExistingInstallPromise = UtilizingExistingInstallPromise;
class FileIsBusy extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FileIsBusy';
    }
    getProperties() {
        return Object.assign(Object.assign({}, super.getProperties()), getDisabledTelemetryOnChance(1));
    }
}
exports.FileIsBusy = FileIsBusy;
class FileIsNotBusy extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FileIsNotBusy';
    }
    getProperties() {
        return Object.assign(Object.assign({}, super.getProperties()), getDisabledTelemetryOnChance(1));
    }
}
exports.FileIsNotBusy = FileIsNotBusy;
class DotnetVersionCategorizedEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetVersionCategorizedEvent';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.DotnetVersionCategorizedEvent = DotnetVersionCategorizedEvent;
class DuplicateInstallDetected extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DuplicateInstallDetected';
    }
}
exports.DuplicateInstallDetected = DuplicateInstallDetected;
class WebRequestTimer extends DotnetCustomMessageEvent {
    constructor(eventMessage, durationMs, finished, url, status) {
        super(eventMessage);
        this.eventMessage = eventMessage;
        this.durationMs = durationMs;
        this.finished = finished;
        this.url = url;
        this.status = status;
    }
    getProperties() {
        return {
            Message: this.eventMessage,
            DurationMs: this.durationMs,
            Finished: this.finished,
            Url: this.url.replace(/\//g, '.'), // urls get redacted as paths, they are not PII able since they are shared common urls. replaceAll may not exist with certain compilers, use regex
            // see: https://github.com/microsoft/vscode/blob/a26fe3e4666aae75fdbfaacf7be153a07bdd12e8/src/vs/platform/telemetry/common/telemetryUtils.ts#L295C20-L295C105
            Status: this.status
        };
    }
}
exports.WebRequestTimer = WebRequestTimer;
class CommandExecutionTimer extends DotnetCustomMessageEvent {
    constructor(eventMessage, durationMs, commandRoot, fullCommandString) {
        super(eventMessage);
        this.eventMessage = eventMessage;
        this.durationMs = durationMs;
        this.commandRoot = commandRoot;
        this.fullCommandString = fullCommandString;
        this.eventName = 'CommandExecutionTimer';
    }
    getProperties() {
        return Object.assign(Object.assign({}, super.getProperties()), { DurationMs: this.durationMs, CommandRoot: TelemetryUtilities_1.TelemetryUtilities.HashAllPaths(this.fullCommandString), HashedFullCommand: TelemetryUtilities_1.TelemetryUtilities.HashData(this.commandRoot) });
    }
}
exports.CommandExecutionTimer = CommandExecutionTimer;
class WebRequestTime extends WebRequestTimer {
    constructor() {
        super(...arguments);
        this.eventName = 'WebRequestTime';
    }
}
exports.WebRequestTime = WebRequestTime;
class WebRequestCachedTime extends WebRequestTimer {
    constructor() {
        super(...arguments);
        this.eventName = 'WebRequestCachedTime';
    }
}
exports.WebRequestCachedTime = WebRequestCachedTime;
class WebRequestTimeUnknown extends WebRequestTimer {
    constructor() {
        super(...arguments);
        this.eventName = 'WebRequestTimeUnknown';
    }
}
exports.WebRequestTimeUnknown = WebRequestTimeUnknown;
class EmptyDirectoryToWipe extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'EmptyDirectoryToWipe';
    }
}
exports.EmptyDirectoryToWipe = EmptyDirectoryToWipe;
class ProxyUsed extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'ProxyUsed';
    }
}
exports.ProxyUsed = ProxyUsed;
class FileToWipe extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FileToWipe';
    }
    getProperties() {
        return Object.assign(Object.assign({}, getDisabledTelemetryOnChance(1)), super.getProperties());
    }
}
exports.FileToWipe = FileToWipe;
class TriedToExitMasterSudoProcess extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'TriedToExitMasterSudoProcess';
    }
}
exports.TriedToExitMasterSudoProcess = TriedToExitMasterSudoProcess;
class FeatureBandDoesNotExist extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FeatureBandDoesNotExist';
    }
}
exports.FeatureBandDoesNotExist = FeatureBandDoesNotExist;
class FileDoesNotExist extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FileDoesNotExist';
    }
}
exports.FileDoesNotExist = FileDoesNotExist;
class DotnetUninstallStarted extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUninstallStarted';
        this.type = EventType_1.EventType.DotnetUninstallMessage;
    }
}
exports.DotnetUninstallStarted = DotnetUninstallStarted;
class DotnetUninstallCompleted extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUninstallStarted';
        this.type = EventType_1.EventType.DotnetUninstallMessage;
    }
}
exports.DotnetUninstallCompleted = DotnetUninstallCompleted;
class DotnetUninstallFailed extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUninstallStarted';
        this.type = EventType_1.EventType.DotnetUninstallMessage;
    }
}
exports.DotnetUninstallFailed = DotnetUninstallFailed;
class DotnetUninstallSkipped extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetUninstallSkipped';
        this.type = EventType_1.EventType.DotnetUninstallMessage;
    }
}
exports.DotnetUninstallSkipped = DotnetUninstallSkipped;
class NoExtensionIdProvided extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'NoExtensionIdProvided';
    }
    getProperties() {
        return Object.assign(Object.assign({}, getDisabledTelemetryOnChance(1)), super.getProperties());
    }
}
exports.NoExtensionIdProvided = NoExtensionIdProvided;
class ConvertingLegacyInstallRecord extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'ConvertingLegacyInstallRecord';
    }
}
exports.ConvertingLegacyInstallRecord = ConvertingLegacyInstallRecord;
class FoundTrackingVersions extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FoundTrackingVersions';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.FoundTrackingVersions = FoundTrackingVersions;
class RemovingVersionFromExtensionState extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'RemovingVersionFromExtensionState';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.RemovingVersionFromExtensionState = RemovingVersionFromExtensionState;
class RemovingExtensionFromList extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'RemovingExtensionFromList';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.RemovingExtensionFromList = RemovingExtensionFromList;
class RemovingOwnerFromList extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'RemovingOwnerFromList';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.RemovingOwnerFromList = RemovingOwnerFromList;
class SkipAddingInstallEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SkipAddingInstallEvent';
    }
}
exports.SkipAddingInstallEvent = SkipAddingInstallEvent;
class AddTrackingVersions extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'AddTrackingVersions';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.AddTrackingVersions = AddTrackingVersions;
class DotnetWSLCheckEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetWSLCheckEvent';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.DotnetWSLCheckEvent = DotnetWSLCheckEvent;
class DotnetWSLOperationOutputEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetWSLOperationOutputEvent';
    }
}
exports.DotnetWSLOperationOutputEvent = DotnetWSLOperationOutputEvent;
class DotnetFindPathCommandInvoked extends DotnetCustomMessageEvent {
    constructor(eventMessage, request) {
        super(eventMessage);
        this.eventMessage = eventMessage;
        this.request = request;
        this.eventName = 'DotnetFindPathCommandInvoked';
    }
    getProperties() {
        return { Message: this.eventMessage, Context: JSON.stringify(this.request) };
    }
    ;
}
exports.DotnetFindPathCommandInvoked = DotnetFindPathCommandInvoked;
class WebCacheClearEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'WebCacheClearEvent';
    }
    getProperties() {
        return Object.assign(Object.assign({}, getDisabledTelemetryOnChance(1)), super.getProperties());
    }
}
exports.WebCacheClearEvent = WebCacheClearEvent;
class CacheClearEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CacheClearEvent';
    }
    getProperties() {
        return Object.assign(Object.assign({}, getDisabledTelemetryOnChance(1)), super.getProperties());
    }
}
exports.CacheClearEvent = CacheClearEvent;
class CachePutEvent extends DotnetCustomMessageEvent {
    constructor(eventMessage, indexStr, value, ttl) {
        super(eventMessage);
        this.eventMessage = eventMessage;
        this.indexStr = indexStr;
        this.value = value;
        this.ttl = ttl;
        this.eventName = 'CachePutEvent';
    }
    getProperties() {
        return Object.assign({ Message: this.eventMessage, indexStr: this.indexStr, value: this.value, ttl: this.ttl }, getDisabledTelemetryOnChance(1));
    }
    ;
}
exports.CachePutEvent = CachePutEvent;
class CacheGetEvent extends DotnetCustomMessageEvent {
    constructor(eventMessage, indexStr, value) {
        super(eventMessage);
        this.eventMessage = eventMessage;
        this.indexStr = indexStr;
        this.value = value;
        this.eventName = 'CacheGetEvent';
    }
    getProperties() {
        return Object.assign({ Message: this.eventMessage, indexStr: this.indexStr, value: this.value }, getDisabledTelemetryOnChance(1));
    }
    ;
}
exports.CacheGetEvent = CacheGetEvent;
class DotnetFindPathLookupSetting extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathLookupSetting';
    }
}
exports.DotnetFindPathLookupSetting = DotnetFindPathLookupSetting;
class CacheAliasCreated extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CacheAliasCreated';
    }
    getProperties() {
        return Object.assign({ Message: this.eventMessage }, getDisabledTelemetryOnChance(1));
    }
    ;
}
exports.CacheAliasCreated = CacheAliasCreated;
class DotnetFindPathSettingFound extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathSettingFound';
    }
}
exports.DotnetFindPathSettingFound = DotnetFindPathSettingFound;
class DotnetFindPathLookupPATH extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathLookupPATH';
    }
}
exports.DotnetFindPathLookupPATH = DotnetFindPathLookupPATH;
class DotnetFindPathPATHFound extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathPATHFound';
    }
}
exports.DotnetFindPathPATHFound = DotnetFindPathPATHFound;
class DotnetFindPathLookupRealPATH extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathLookupRealPATH';
    }
}
exports.DotnetFindPathLookupRealPATH = DotnetFindPathLookupRealPATH;
class DotnetFindPathRealPATHFound extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathRealPATHFound';
    }
}
exports.DotnetFindPathRealPATHFound = DotnetFindPathRealPATHFound;
class DotnetConditionsValidated extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetConditionsValidated';
    }
    getProperties() {
        return Object.assign(Object.assign({}, getDisabledTelemetryOnChance(1)), super.getProperties());
    }
}
exports.DotnetConditionsValidated = DotnetConditionsValidated;
class DotnetFindPathHostFxrResolutionLookup extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathHostFxrResolutionLookup';
    }
}
exports.DotnetFindPathHostFxrResolutionLookup = DotnetFindPathHostFxrResolutionLookup;
class DotnetFindPathOnRegistry extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathOnRegistry';
    }
}
exports.DotnetFindPathOnRegistry = DotnetFindPathOnRegistry;
class DotnetFindPathNoHostOnRegistry extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathNoHostOnRegistry';
    }
}
exports.DotnetFindPathNoHostOnRegistry = DotnetFindPathNoHostOnRegistry;
class SudoDirCreationFailed extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoDirCreationFailed';
    }
}
exports.SudoDirCreationFailed = SudoDirCreationFailed;
class SudoDirDeletionFailed extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoDirDeletionFailed';
    }
}
exports.SudoDirDeletionFailed = SudoDirDeletionFailed;
class DotnetFindPathOnFileSystem extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathOnFileSystem';
    }
}
exports.DotnetFindPathOnFileSystem = DotnetFindPathOnFileSystem;
class DotnetFindPathNoHostOnFileSystem extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathNoHostOnFileSystem';
    }
}
exports.DotnetFindPathNoHostOnFileSystem = DotnetFindPathNoHostOnFileSystem;
class DotnetFindPathNoRuntimesOnHost extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathNoRuntimesOnHost';
    }
}
exports.DotnetFindPathNoRuntimesOnHost = DotnetFindPathNoRuntimesOnHost;
class DotnetFindPathLookupRootPATH extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathLookupRealPATH';
    }
}
exports.DotnetFindPathLookupRootPATH = DotnetFindPathLookupRootPATH;
class DotnetFindPathRootEmulationPATHFound extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathRealPATHFound';
    }
}
exports.DotnetFindPathRootEmulationPATHFound = DotnetFindPathRootEmulationPATHFound;
class DotnetFindPathRootUnderEmulationButNoneSet extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathRealPATHFound';
    }
}
exports.DotnetFindPathRootUnderEmulationButNoneSet = DotnetFindPathRootUnderEmulationButNoneSet;
class DotnetFindPathRootPATHFound extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathRealPATHFound';
    }
}
exports.DotnetFindPathRootPATHFound = DotnetFindPathRootPATHFound;
class DotnetFindPathMetCondition extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathMetCondition';
    }
}
exports.DotnetFindPathMetCondition = DotnetFindPathMetCondition;
class DotnetFindPathNoPathMetCondition extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathNoPathMetCondition';
    }
}
exports.DotnetFindPathNoPathMetCondition = DotnetFindPathNoPathMetCondition;
class DotnetFindPathDidNotMeetCondition extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFindPathDidNotMeetCondition';
    }
}
exports.DotnetFindPathDidNotMeetCondition = DotnetFindPathDidNotMeetCondition;
class DotnetTelemetrySettingEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetTelemetrySettingEvent';
    }
}
exports.DotnetTelemetrySettingEvent = DotnetTelemetrySettingEvent;
class DistroSupport extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DistroSupport';
    }
}
exports.DistroSupport = DistroSupport;
class FeedInjection extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FeedInjection';
    }
}
exports.FeedInjection = FeedInjection;
class FeedInjectionStarted extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.type = EventType_1.EventType.FeedInjectionMessage;
        this.eventName = 'FeedInjectionStarted';
    }
}
exports.FeedInjectionStarted = FeedInjectionStarted;
class FeedInjectionFinished extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.type = EventType_1.EventType.FeedInjectionMessage;
        this.eventName = 'FeedInjectionFinished';
    }
}
exports.FeedInjectionFinished = FeedInjectionFinished;
class DistroPackagesSearch extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DistroPackagesSearch';
    }
}
exports.DistroPackagesSearch = DistroPackagesSearch;
class FoundDistroVersionDetails extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FoundDistroVersionDetails';
    }
}
exports.FoundDistroVersionDetails = FoundDistroVersionDetails;
class DotnetVSCodeExtensionFound extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetVSCodeExtensionFound';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.DotnetVSCodeExtensionFound = DotnetVSCodeExtensionFound;
class DotnetVSCodeExtensionHasInstallRequest extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetVSCodeExtensionHasInstallRequest';
    }
}
exports.DotnetVSCodeExtensionHasInstallRequest = DotnetVSCodeExtensionHasInstallRequest;
class DotnetVSCodeExtensionChange extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetVSCodeExtensionChange';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.DotnetVSCodeExtensionChange = DotnetVSCodeExtensionChange;
class DotnetCommandNotFoundEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetCommandNotFoundEvent';
    }
}
exports.DotnetCommandNotFoundEvent = DotnetCommandNotFoundEvent;
class DotnetFileIntegrityCheckEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFileIntegrityCheckEvent';
    }
}
exports.DotnetFileIntegrityCheckEvent = DotnetFileIntegrityCheckEvent;
class GlobalAcquisitionContextMenuOpened extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'GlobalAcquisitionContextMenuOpened';
    }
}
exports.GlobalAcquisitionContextMenuOpened = GlobalAcquisitionContextMenuOpened;
class UserManualInstallVersionChosen extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'UserManualInstallVersionChosen';
    }
}
exports.UserManualInstallVersionChosen = UserManualInstallVersionChosen;
class UserManualInstallRequested extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'UserManualInstallRequested';
    }
}
exports.UserManualInstallRequested = UserManualInstallRequested;
class UserManualInstallSuccess extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'UserManualInstallSuccess';
    }
}
exports.UserManualInstallSuccess = UserManualInstallSuccess;
class CommandExecutionStdOut extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionStdOut';
    }
}
exports.CommandExecutionStdOut = CommandExecutionStdOut;
class NoMatchingInstallToStopTracking extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'NoMatchingInstallToStopTracking';
    }
}
exports.NoMatchingInstallToStopTracking = NoMatchingInstallToStopTracking;
class CommandExecutionStdError extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionStdError';
    }
}
exports.CommandExecutionStdError = CommandExecutionStdError;
class DotnetGlobalAcquisitionBeginEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalAcquisitionBeginEvent';
    }
}
exports.DotnetGlobalAcquisitionBeginEvent = DotnetGlobalAcquisitionBeginEvent;
class DotnetGlobalVersionResolutionCompletionEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalVersionResolutionCompletionEvent';
    }
}
exports.DotnetGlobalVersionResolutionCompletionEvent = DotnetGlobalVersionResolutionCompletionEvent;
class CommandProcessesExecutionFailureNonTerminal extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandProcessesExecutionFailureNonTerminal';
    }
}
exports.CommandProcessesExecutionFailureNonTerminal = CommandProcessesExecutionFailureNonTerminal;
class CommandProcessorExecutionBegin extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandProcessorExecutionBegin';
    }
}
exports.CommandProcessorExecutionBegin = CommandProcessorExecutionBegin;
class CommandProcessorExecutionEnd extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandProcessorExecutionEnd';
    }
}
exports.CommandProcessorExecutionEnd = CommandProcessorExecutionEnd;
class DotnetBeginGlobalInstallerExecution extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetBeginGlobalInstallerExecution';
    }
}
exports.DotnetBeginGlobalInstallerExecution = DotnetBeginGlobalInstallerExecution;
class DotnetCompletedGlobalInstallerExecution extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetCompletedGlobalInstallerExecution';
    }
}
exports.DotnetCompletedGlobalInstallerExecution = DotnetCompletedGlobalInstallerExecution;
class DotnetGlobalAcquisitionCompletionEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetGlobalAcquisitionCompletionEvent';
    }
}
exports.DotnetGlobalAcquisitionCompletionEvent = DotnetGlobalAcquisitionCompletionEvent;
class DotnetAlternativeCommandFoundEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAlternativeCommandFoundEvent';
    }
}
exports.DotnetAlternativeCommandFoundEvent = DotnetAlternativeCommandFoundEvent;
class DotnetCommandFallbackArchitectureEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetCommandFallbackArchitectureEvent';
    }
}
exports.DotnetCommandFallbackArchitectureEvent = DotnetCommandFallbackArchitectureEvent;
class DotnetCommandFallbackOSEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetCommandFallbackOSEvent';
    }
}
exports.DotnetCommandFallbackOSEvent = DotnetCommandFallbackOSEvent;
class DotnetInstallIdCreatedEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInstallIdCreatedEvent';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.DotnetInstallIdCreatedEvent = DotnetInstallIdCreatedEvent;
class DotnetLegacyInstallDetectedEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetLegacyInstallDetectedEvent';
    }
}
exports.DotnetLegacyInstallDetectedEvent = DotnetLegacyInstallDetectedEvent;
class DotnetLegacyInstallRemovalRequestEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetLegacyInstallRemovalRequestEvent';
    }
}
exports.DotnetLegacyInstallRemovalRequestEvent = DotnetLegacyInstallRemovalRequestEvent;
class DotnetFakeSDKEnvironmentVariableTriggered extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFakeSDKEnvironmentVariableTriggered';
    }
}
exports.DotnetFakeSDKEnvironmentVariableTriggered = DotnetFakeSDKEnvironmentVariableTriggered;
class CommandExecutionNoStatusCodeWarning extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionNoStatusCodeWarning';
    }
}
exports.CommandExecutionNoStatusCodeWarning = CommandExecutionNoStatusCodeWarning;
class CommandExecutionSignalSentEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionSignalSentEvent';
    }
}
exports.CommandExecutionSignalSentEvent = CommandExecutionSignalSentEvent;
class CommandExecutionStatusEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionStatusEvent';
    }
}
exports.CommandExecutionStatusEvent = CommandExecutionStatusEvent;
class CommandExecutionEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionEvent';
    }
}
exports.CommandExecutionEvent = CommandExecutionEvent;
class SudoProcAliveCheckBegin extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoProcAliveCheckBegin';
    }
}
exports.SudoProcAliveCheckBegin = SudoProcAliveCheckBegin;
class SudoProcAliveCheckEnd extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoProcAliveCheckEnd';
    }
}
exports.SudoProcAliveCheckEnd = SudoProcAliveCheckEnd;
class SudoProcCommandExchangeBegin extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoProcCommandExchangeBegin';
    }
}
exports.SudoProcCommandExchangeBegin = SudoProcCommandExchangeBegin;
class SudoProcCommandExchangePing extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoProcCommandExchangePing';
    }
}
exports.SudoProcCommandExchangePing = SudoProcCommandExchangePing;
class WaitingForDotnetInstallerResponse extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'WaitingForDotnetInstallerResponse';
    }
}
exports.WaitingForDotnetInstallerResponse = WaitingForDotnetInstallerResponse;
class SudoProcCommandExchangeEnd extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'SudoProcCommandExchangeEnd';
    }
}
exports.SudoProcCommandExchangeEnd = SudoProcCommandExchangeEnd;
class CommandExecutionUserAskDialogueEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionUserAskDialogueEvent';
    }
}
exports.CommandExecutionUserAskDialogueEvent = CommandExecutionUserAskDialogueEvent;
class CommandExecutionUserCompletedDialogueEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionUserCompletedDialogueEvent';
    }
}
exports.CommandExecutionUserCompletedDialogueEvent = CommandExecutionUserCompletedDialogueEvent;
class CommandExecutionUnderSudoEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionUnderSudoEvent';
    }
    getProperties() {
        return Object.assign(Object.assign({}, getDisabledTelemetryOnChance(1)), super.getProperties());
    }
}
exports.CommandExecutionUnderSudoEvent = CommandExecutionUnderSudoEvent;
class CommandExecutionUserRejectedPasswordRequest extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionUserRejectedPasswordRequest';
    }
}
exports.CommandExecutionUserRejectedPasswordRequest = CommandExecutionUserRejectedPasswordRequest;
class CommandExecutionUnknownCommandExecutionAttempt extends DotnetInstallExpectedAbort {
    constructor() {
        super(...arguments);
        this.eventName = 'CommandExecutionUnknownCommandExecutionAttempt';
    }
}
exports.CommandExecutionUnknownCommandExecutionAttempt = CommandExecutionUnknownCommandExecutionAttempt;
class DotnetVersionParseEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetVersionParseEvent';
    }
}
exports.DotnetVersionParseEvent = DotnetVersionParseEvent;
class DotnetUpgradedEvent extends DotnetCustomMessageEvent {
    constructor(eventMsg) {
        super(eventMsg);
        this.eventName = 'DotnetUpgradedEvent';
        this.type = EventType_1.EventType.DotnetUpgradedEvent;
    }
}
exports.DotnetUpgradedEvent = DotnetUpgradedEvent;
class DotnetOfflineInstallUsed extends DotnetCustomMessageEvent {
    constructor(eventMsg) {
        super(eventMsg);
        this.eventName = 'DotnetOfflineInstallUsed';
        this.type = EventType_1.EventType.OfflineInstallUsed;
    }
}
exports.DotnetOfflineInstallUsed = DotnetOfflineInstallUsed;
class DotnetOfflineWarning extends DotnetCustomMessageEvent {
    constructor(eventMsg) {
        super(eventMsg);
        this.eventName = 'DotnetOfflineWarning';
        this.type = EventType_1.EventType.OfflineWarning;
    }
}
exports.DotnetOfflineWarning = DotnetOfflineWarning;
class NetInstallerBeginExecutionEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'NetInstallerBeginExecutionEvent';
    }
}
exports.NetInstallerBeginExecutionEvent = NetInstallerBeginExecutionEvent;
class NetInstallerEndExecutionEvent extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'NetInstallerEndExecutionEvent';
    }
}
exports.NetInstallerEndExecutionEvent = NetInstallerEndExecutionEvent;
class FailedToRunSudoCommand extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'FailedToRunSudoCommand';
    }
}
exports.FailedToRunSudoCommand = FailedToRunSudoCommand;
class DotnetInstallLinuxChecks extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetInstallLinuxChecks';
    }
}
exports.DotnetInstallLinuxChecks = DotnetInstallLinuxChecks;
class DotnetFileEvent extends DotnetAcquisitionMessage {
    constructor(eventMessage, time, file) {
        super();
        this.eventMessage = eventMessage;
        this.time = time;
        this.file = file;
    }
    getProperties() {
        return { Message: this.eventMessage, Time: this.time, File: TelemetryUtilities_1.TelemetryUtilities.HashData(this.file) };
    }
}
exports.DotnetFileEvent = DotnetFileEvent;
class DotnetLockEvent extends DotnetFileEvent {
    constructor(eventMessage, time, lock, file) {
        super(eventMessage, time, file);
        this.eventMessage = eventMessage;
        this.time = time;
        this.lock = lock;
        this.file = file;
    }
    getProperties() {
        return Object.assign({ Message: this.eventMessage, Time: this.time, Lock: this.lock, File: this.file }, getDisabledTelemetryOnChance(1));
    }
}
exports.DotnetLockEvent = DotnetLockEvent;
class GenericDotnetLockEvent extends DotnetLockEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'GenericDotnetLockEvent';
    }
}
exports.GenericDotnetLockEvent = GenericDotnetLockEvent;
class DotnetFileWriteRequestEvent extends DotnetFileEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetFileWriteRequestEvent';
    }
    getProperties() {
        return Object.assign({ suppressTelemetry: 'true' }, super.getProperties());
    }
}
exports.DotnetFileWriteRequestEvent = DotnetFileWriteRequestEvent;
class DotnetAcquisitionPartialInstallation extends DotnetAcquisitionMessage {
    constructor(install) {
        super();
        this.install = install;
        this.eventName = 'DotnetAcquisitionPartialInstallation';
    }
    getProperties() {
        return Object.assign(Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.install)), { PartialInstallationInstallId: this.install.installId });
    }
}
exports.DotnetAcquisitionPartialInstallation = DotnetAcquisitionPartialInstallation;
class DotnetAcquisitionInProgress extends IEvent_1.IEvent {
    constructor(install, requestingExtensionId) {
        super();
        this.install = install;
        this.requestingExtensionId = requestingExtensionId;
        this.type = EventType_1.EventType.DotnetAcquisitionInProgress;
        this.eventName = 'DotnetAcquisitionInProgress';
    }
    getProperties() {
        return Object.assign(Object.assign({ InProgressInstallationInstallId: this.install.installId }, (0, DotnetInstall_1.InstallToStrings)(this.install)), { extensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingExtensionId) });
    }
}
exports.DotnetAcquisitionInProgress = DotnetAcquisitionInProgress;
class DotnetAcquisitionAlreadyInstalled extends IEvent_1.IEvent {
    constructor(install, requestingExtensionId) {
        super();
        this.install = install;
        this.requestingExtensionId = requestingExtensionId;
        this.eventName = 'DotnetAcquisitionAlreadyInstalled';
        this.type = EventType_1.EventType.DotnetAcquisitionAlreadyInstalled;
    }
    getProperties() {
        return Object.assign(Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.install)), { extensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingExtensionId) });
    }
}
exports.DotnetAcquisitionAlreadyInstalled = DotnetAcquisitionAlreadyInstalled;
class DotnetAcquisitionMissingLinuxDependencies extends DotnetAcquisitionMessage {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAcquisitionMissingLinuxDependencies';
    }
}
exports.DotnetAcquisitionMissingLinuxDependencies = DotnetAcquisitionMissingLinuxDependencies;
class DotnetAcquisitionThoughtInstalledButNot extends DotnetCustomMessageEvent {
    constructor() {
        super(...arguments);
        this.eventName = 'DotnetAcquisitionThoughtInstalledButNot';
    }
}
exports.DotnetAcquisitionThoughtInstalledButNot = DotnetAcquisitionThoughtInstalledButNot;
class DotnetAcquisitionScriptOutput extends DotnetAcquisitionMessage {
    constructor(install, output) {
        super();
        this.install = install;
        this.output = output;
        this.eventName = 'DotnetAcquisitionScriptOutput';
        this.isError = true;
    }
    getProperties(telemetry = false) {
        return Object.assign(Object.assign({ AcquisitionInstallId: this.install.installId }, (0, DotnetInstall_1.InstallToStrings)(this.install)), { ScriptOutput: this.output });
    }
}
exports.DotnetAcquisitionScriptOutput = DotnetAcquisitionScriptOutput;
class DotnetInstallationValidated extends DotnetAcquisitionMessage {
    constructor(install) {
        super();
        this.install = install;
        this.eventName = 'DotnetInstallationValidated';
    }
    getProperties(telemetry = false) {
        return Object.assign({ ValidatedInstallId: this.install.installId }, (0, DotnetInstall_1.InstallToStrings)(this.install));
    }
}
exports.DotnetInstallationValidated = DotnetInstallationValidated;
class DotnetAcquisitionStatusRequested extends DotnetAcquisitionMessage {
    constructor(version, requestingId = '') {
        super();
        this.version = version;
        this.requestingId = requestingId;
        this.eventName = 'DotnetAcquisitionStatusRequested';
    }
    getProperties() {
        return {
            AcquisitionStartVersion: this.version,
            RequestingExtensionId: TelemetryUtilities_1.TelemetryUtilities.HashData(this.requestingId)
        };
    }
}
exports.DotnetAcquisitionStatusRequested = DotnetAcquisitionStatusRequested;
class DotnetAcquisitionStatusUndefined extends DotnetAcquisitionMessage {
    constructor(installId) {
        super();
        this.installId = installId;
        this.eventName = 'DotnetAcquisitionStatusUndefined';
    }
    getProperties() {
        return Object.assign({ AcquisitionStatusInstallId: this.installId.installId }, (0, DotnetInstall_1.InstallToStrings)(this.installId));
    }
}
exports.DotnetAcquisitionStatusUndefined = DotnetAcquisitionStatusUndefined;
class DotnetAcquisitionStatusResolved extends DotnetAcquisitionMessage {
    constructor(installId, version) {
        super();
        this.installId = installId;
        this.version = version;
        this.eventName = 'DotnetAcquisitionStatusResolved';
    }
    getProperties() {
        return Object.assign(Object.assign({ AcquisitionStatusInstallId: this.installId.installId }, (0, DotnetInstall_1.InstallToStrings)(this.installId)), { AcquisitionStatusVersion: this.version });
    }
}
exports.DotnetAcquisitionStatusResolved = DotnetAcquisitionStatusResolved;
class WebRequestSent extends DotnetAcquisitionMessage {
    constructor(url) {
        super();
        this.url = url;
        this.eventName = 'WebRequestSent';
    }
    getProperties() {
        return { WebRequestUri: this.url };
    }
}
exports.WebRequestSent = WebRequestSent;
class WebRequestUsingAltClient extends DotnetAcquisitionMessage {
    constructor(url, msg) {
        super();
        this.url = url;
        this.msg = msg;
        this.eventName = 'WebRequestUsingAltClient';
    }
    getProperties() {
        return { WebRequestUri: this.url, Message: this.msg };
    }
}
exports.WebRequestUsingAltClient = WebRequestUsingAltClient;
class WebRequestInitiated extends DotnetAcquisitionMessage {
    constructor(url) {
        super();
        this.url = url;
        this.eventName = 'WebRequestInitiated';
    }
    getProperties() {
        return { WebRequestUri: this.url };
    }
}
exports.WebRequestInitiated = WebRequestInitiated;
class DotnetPreinstallDetected extends DotnetAcquisitionMessage {
    constructor(installId) {
        super();
        this.installId = installId;
        this.eventName = 'DotnetPreinstallDetected';
    }
    getProperties() {
        return Object.assign(Object.assign({}, (0, DotnetInstall_1.InstallToStrings)(this.installId)), { PreinstalledInstallId: this.installId.installId });
    }
}
exports.DotnetPreinstallDetected = DotnetPreinstallDetected;
class TestAcquireCalled extends IEvent_1.IEvent {
    constructor(context) {
        super();
        this.context = context;
        this.eventName = 'TestAcquireCalled';
        this.type = EventType_1.EventType.DotnetAcquisitionTest;
    }
    getProperties() {
        return undefined;
    }
}
exports.TestAcquireCalled = TestAcquireCalled;
function getDisabledTelemetryOnChance(percentIntToSend) {
    return { suppressTelemetry: (!(Math.random() < percentIntToSend / 100)).toString() };
}
//# sourceMappingURL=EventStreamEvents.js.map